// extracted by mini-css-extract-plugin
export var editor = "_15-0";
export var flowSidebar = "_45-2";